module.exports = __webpack_public_path__ + "img/proEmpty.c4086fb2.png";